// extracted by mini-css-extract-plugin
export default {"productTable":"productTable_productTable__0ybIF","scorer":"productTable_scorer__hYUaM"};